<template>
<div>
	<project-change-orders v-if="!changeOrderSlug"></project-change-orders>
	<project-change-order v-else
		:change-order-slug="changeOrderSlug"
		v-on:slugChange="setSlug">
	</project-change-order>
</div>
</template>
<script type="text/javascript">
import ProjectChangeOrder from "./change_orders/ProjectChangeOrder"
import ProjectChangeOrders from "./change_orders/ProjectChangeOrders"

export default {
	name: "ProjectQuoting",
	components: {
		ProjectChangeOrder,
		ProjectChangeOrders
	},
	mixins: [],
	data() {
		return {
			listView: true,
			changeOrderSlug: null
		}
	},
	watch: {

	},
	computed: {

	},
	methods: {
		setSlug(slug) {
			this.changeOrderSlug = slug
		}
	},
	created() {
		if ("tag" in this.$route.params) {
			this.changeOrderSlug = this.$route.params.tag
			this.listView = false
		}
	}
}
</script>